module.exports = __webpack_public_path__ + "static/dancing-with-life-5ee77140117ccdfe11b3d91df1f20bf4.jpg";